import { getNestedObjects, setNestedObjects } from '@utils/nestedObjects';

import { isEmpty, isEmptyArray, isNotStrongPassword } from './validator';

type TValidationCheck = {
  reduxActionName: string;
  formData: any;
};

export function validationCheck({ reduxActionName, formData }: TValidationCheck): any {
  let messages: any = {};
  switch (reduxActionName) {
    case 'sign-in':
      if (isEmpty(formData?.userId)) {
        messages.userId = { id: 'validation.required' };
      }
      if (isEmpty(formData?.password)) {
        messages.password = { id: 'validation.required' };
      }
      break;
    case 'sample-form':
      if (isEmpty(formData?.text1)) {
        messages.text1 = { id: 'validation.required' };
      }
      if (isNotStrongPassword(formData?.password2)) {
        messages.password2 = { id: 'validation.isNotStrongPassword' };
      }
      if (isEmptyArray(formData?.check3)) {
        messages.check3 = { id: 'validation.isEmptyArray' };
      }
      if (isEmpty(getNestedObjects([`text7`, 0, 'name'], formData))) {
        messages = setNestedObjects([`text7`, 0, 'name'], { id: 'validation.text7nestedTest' }, messages);
      }
      break;
    default:
      break;
  }
  return messages;
}

export function constructValidationChecker(reduxActionName: string) {
  return (name: string | number | (string | number)[], value: any, formData: any): Record<string, any> =>
    validationCheck({ reduxActionName, formData: setNestedObjects(name, value, formData) });
}
